import { render, staticRenderFns } from "./GarageSalaryMultiAssign.vue?vue&type=template&id=e81c8b6c&"
import script from "./GarageSalaryMultiAssign.vue?vue&type=script&lang=js&"
export * from "./GarageSalaryMultiAssign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports